import React from "react";
import { FaWhatsapp } from "react-icons/fa";

interface WhatsAppLinkProps {
  phoneNumber: string;
  displayNumber: string;
  message?: string;
  iconSize?: number;
  iconColor?: string;
  textStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}

const WhatsAppLink: React.FC<WhatsAppLinkProps> = ({
  phoneNumber = "+529991370515",
  displayNumber = "(999) 137 0515)",
  message = "Buenos días! Me gustaria saber más sobre Vegan Vegetarian.",
  iconSize = 20,
  iconColor = "#25D366",
  textStyle = {},
  containerStyle = {},
}) => {
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(
    /\D/g,
    ""
  )}?text=${encodeURIComponent(message)}`;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        ...containerStyle,
      }}
    >
      <span style={{ ...textStyle }}>{displayNumber}</span>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        style={{ display: "inline-flex" }}
      >
        <FaWhatsapp size={iconSize} color={iconColor} />
      </a>
    </div>
  );
};

export default WhatsAppLink;
